import type { FlowStep, FlowStepConfig } from '../types/flowConfig.types'

/** Configuração inicial por tipo (espelha o comportamento do FlowEditor). */
export function getDefaultFlowStepConfig(type: FlowStep['type']): FlowStepConfig {
  switch (type) {
    case 'data_collection':
      return {
        prompt: 'Digite as informações solicitadas:',
        validation: 'text',
        required: true
      }
    case 'api_call':
      return {
        api_url: '',
        api_method: 'GET',
        api_token: '',
        require_success_true: false,
        auth_source: 'manual',
        credential_key: '',
        auth_token_field: '',
        api_headers: {},
        api_body: {},
        response_mapping: {}
      }
    case 'credential_ref':
      return {
        credential_key: ''
      }
    case 'auth_session':
      return {
        credential_key: '',
        auth_endpoint: '',
        token_response_path: '$raw',
        store_as: 'auth.jwt'
      }
    case 'conditional':
      return {
        conditions: [],
        default_template: '',
        default_step: ''
      }
    case 'dynamic_conditional':
      return {
        dynamic_conditions: {},
        conditions: [],
        default_template: '',
        default_step: ''
      }
    case 'list_selection':
      return {
        list_data: [],
        display_field: 'name',
        value_field: 'id',
        storage_field: 'selected_value',
        prompt_message: '',
        selection_instruction: 'Digite o *número* da opção desejada.',
        invalid_option_message: 'Opção inválida. Digite um número da lista.'
      }
    case 'dynamic_list':
      return {
        items_source_field: 'last_api_response_items',
        display_field: 'name',
        value_field: 'id',
        storage_field: 'selected_value',
        prompt_message: '',
        selection_instruction: 'Digite o *número* da opção desejada.',
        invalid_option_message: 'Opção inválida. Digite um número da lista.'
      }
    case 'item_selection':
      return {
        items_source_field: 'last_api_response_items',
        items_path: '',
        display_field: 'name',
        value_field: 'id',
        display_template: '',
        storage_field: 'selected_value',
        store_selection_index_as: 'selected_item',
        store_selected_object_as: '',
        prompt_message: '',
        selection_instruction: 'Digite o *número* da opção desejada.',
        invalid_option_message: 'Opção inválida. Digite um número da lista.'
      }
    case 'message_dispatch':
      return {
        mode: 'single',
        source_field: 'last_api_response',
        messages_path: '',
        single_message_path: '',
        should_finalize_path: '',
        fallback_message: 'Processamento concluído.',
        delay_between_messages_ms: 1000
      }
    case 'transfer_human':
      return {
        transfer_title: '',
        transfer_message: ''
      }
    case 'finalization':
      return {
        message: 'Processo finalizado com sucesso!',
        clear_data: true
      }
    default:
      return {}
  }
}
